





















import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { UserData } from '@/views/users/Users';

@Component({})
export default class UsersTableBody extends Vue {
  @Prop() rows!: UserData[]
  @Prop() methods? : Function
  
  public clicktr (tr: UserData) {
    const { hoverFlat } = this.$attrs
    if (hoverFlat) return;
    const { user_id } = tr;
    if (user_id) return this.$router.push(`/users/${tr.user_id}`);
  }
}
